import React from 'react'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { Switch } from '@mui/material'
import { useEEIIIPCalls } from '../../hooks'
import { useLoaderBasic } from '../../../loader/hooks'
import { useModalContext, ConfirmationDialog } from '../../../../ui'
import feedback from '../../../../core/feedback'
import { useIntl } from 'react-intl'

const StyledSwitch = styled(Switch)(({ theme }) => ({
  marginRight: 10,
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[500],
  },
}))

export const TableActions = ({ rowData, row }) => {
  const intl = useIntl()
  const { formatMessage } = intl
  const permissions = useSelector((state) => state.global.permissions)
  const { switchCompanyState } = useEEIIIPCalls()
  const { addExtra } = useLoaderBasic({ identifier: 'eeiiIp' })
  const {
    actions: { open },
  } = useModalContext()
  const eeiiIpLoader = useSelector((state) => state.loader.eeiiIp)

  const actualRowData = rowData || row?.original || {}

  if (!actualRowData || typeof actualRowData !== 'object' || actualRowData.id === undefined) {
    return <span>--</span>
  }

  const rowState = actualRowData.activo
  const eeiiIpData = eeiiIpLoader?.data
  const eeiiIpCompanies = eeiiIpLoader?.data?.empresas || []

  const handleToggleState = () =>
    new Promise(function (resolve, reject) {
      const companyId = actualRowData.id
      switchCompanyState(companyId)
        .then(({ data }) => {
          const { activo: updatedState } = data
          const updatedEeiiIpCompanies = eeiiIpCompanies.map((e) => {
            return e.id === companyId ? { ...e, activo: updatedState } : e
          })

          addExtra({ data: { ...eeiiIpData, empresas: updatedEeiiIpCompanies } })
          resolve()
        })
        .catch((response) => {
          feedback('error', response?.data?.message || 'No se ha podido completar la operación')
          console.error('Error changing company state')
          reject()
        })
    })

  const handleSwitch = (event) => {
    event.stopPropagation()
    open({
      Component: ConfirmationDialog,
      data: {
        title: formatMessage(
          {
            id: `pages.eeiiIp.switchCompanyDialog.${
              actualRowData.activo ? 'deactivate' : 'activate'
            }.title`,
          },
          { company: actualRowData.nombre }
        ),
        text: formatMessage(
          {
            id: `pages.eeiiIp.switchCompanyDialog.${
              actualRowData.activo ? 'deactivate' : 'activate'
            }.desc`,
          },
          { company: actualRowData.nombre }
        ),
        yesText: formatMessage({ id: 'pages.eeiiIp.switchCompanyDialog.confirm' }),
        noText: formatMessage({ id: 'pages.eeiiIp.switchCompanyDialog.cancel' }),
        yesAction: handleToggleState,
      },
      type: 'centered',
    })
  }

  return (
    <StyledSwitch
      checked={!!rowState}
      onClick={handleSwitch}
      disabled={!permissions.desactivar_empresa}
    />
  )
}
